import store from 'dashboard/store';
import { isHiddenFeature } from 'dashboard/ceHiddenFeatures';

/**
 * True when this deployment should be treated as Community Edition: not
 * Chatwoot Cloud, and either no enterprise/ directory on disk or no paid
 * enterprise plan.
 *
 * `window.chatwootConfig.isEnterprise` is rendered by
 * app/views/layouts/vueapp.html.erb from ChatwootApp.enterprise?, which is
 * whether the enterprise/ directory exists — TRUE on a stock installer
 * deploy (the git checkout ships enterprise/), so the pricing-plan check
 * ('community' = unlicensed) is what actually fires on our boxes. Keep in
 * sync with the same predicate in composables/usePolicy.js.
 */
export const isCommunityInstallation = () => {
  const config = window.chatwootConfig || {};
  return (
    !store.getters['globalConfig/isOnChatwootCloud'] &&
    (config.isEnterprise !== 'true' ||
      config.enterprisePlanName === 'community')
  );
};

/**
 * Blocks direct URL navigation to a route gated behind a feature the account
 * cannot use. Hiding the sidebar entry is not enough on its own: routes stay
 * registered, so /accounts/1/settings/sla is still reachable by typing it.
 *
 * @param {import('vue-router').RouteLocationNormalized} to
 * @returns {boolean}
 */
export const isRouteBlockedOnCommunity = to => {
  if (!isCommunityInstallation()) return false;

  const featureFlag = to?.meta?.featureFlag;
  if (!featureFlag) return false;

  if (isHiddenFeature(featureFlag)) return true;

  const accountId =
    Number(to.params?.accountId) || store.getters.getCurrentAccountId;

  // Store not hydrated yet (cold page load / hard refresh): fail open.
  // Premium routes are still blocked by the static isHiddenFeature list
  // above; only the account-flag check depends on store state.
  const account = store.getters['accounts/getAccount'](accountId);
  if (!account || !account.id) return false;

  return !store.getters['accounts/isFeatureEnabledonAccount'](
    accountId,
    featureFlag
  );
};
